import { Maybe } from 'maybe-not';
import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';

export default function scrollToTop(moduleId: string, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('scrollToTop') || !moduleId.includes('tectonRoute')) {
        return;
    }

    return function(): void {
        sendMessage('scrollToTop', Maybe.nothing<string>());
    };
}
